import type { Ref } from "vue";
import LxcError from "~/core/models/LxcError.class";
import dtwinsService from "~/modules/dtwin/services/dtwin.service";

export function useUpdateDtwinConfiguration({
  organizationCode,
}: {
  organizationCode?: number;
}) {
  const error: Ref<LxcError | undefined> = ref();

  const isLoading = ref(false);

  async function updateDtwinConfiguration(
    contentResourceUid: string,
    configurationForm: Record<string, string>,
  ) {
    isLoading.value = true;

    error.value = undefined;

    const response = await dtwinsService.updateConfigurationFiles(
      contentResourceUid,
      configurationForm,
      organizationCode,
    );

    if (LxcError.check(response)) {
      error.value = response;
    }

    isLoading.value = false;
  }

  return {
    updateDtwinConfiguration,
    error,
    isLoading,
  };
}
